var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('span',{staticClass:"headline"},[_vm._v("Hello, "+_vm._s(_vm.firstName)+".")])])}
var staticRenderFns = []

export { render, staticRenderFns }